import { Injectable } from "@angular/core";
import { AccountService as AccountServiceCore } from "core-kit";

@Injectable()
export class AccountService extends AccountServiceCore {}
